import { arrowBottomIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import Button from '../Button'
import style from './styles/specialties.module.scss'

interface IProps {
  name: string
  description: string
  form: string
  period: string
  medicalCheckup: string
  url: string
}

const SpecialtiesCard = ({
  name,
  description,
  form,
  period,
  medicalCheckup,
  url
}: IProps): React.ReactElement => {
  const [opened, setOpened] = useState(false)
  const [isInfo, setIsinfo] = useState(false)

  const handleToggleOpen = (): void => {
    setOpened(!opened)
  }

  useEffect(() => {
    const isInfo =
      Boolean(description) ||
      Boolean(form) ||
      Boolean(period) ||
      Boolean(medicalCheckup)
    setIsinfo(isInfo)
  }, [description, form, period, medicalCheckup])
  return (
    <div
      className={classNames({
        [style.spec]: true,
        [style['spec--opened']]: opened
      })}
    >
      <button
        type='button'
        className={style.spec__button}
        onClick={handleToggleOpen}
      >
        <span className={style.spec__title}>{name}</span>
        <GxIcon
          src={arrowBottomIcon}
          className={classNames({
            [style.spec__icon]: true,
            [style['spec__icon--opened']]: opened
          })}
        />
      </button>

      <div
        className={classNames({
          [style.spec_content]: true,
          [style['spec_content--opened']]: opened
        })}
      >
        <p className={style.spec__desc}>
          {isInfo ? description : 'Информация не найдена'}
        </p>
        <ul className={style.spec_right}>
          {form !== ''
            ? (
              <li className={style.spec__item}>
                Форма обучения:<span className={style.spec__meaning}>{form}</span>
              </li>
              )
            : null}
          {period !== ''
            ? (
              <li className={style.spec__item}>
                Срок обучения:
                <span className={style.spec__meaning}>{period}</span>
              </li>
              )
            : null}
          {medicalCheckup !== ''
            ? (
              <li className={style.spec__item}>
                Медицинский осмотр:
                <span className={style.spec__meaning}>{medicalCheckup}</span>
              </li>
              )
            : null}
        </ul>
      </div>

      {url !== ''
        ? (
          <Button
            corner
            wide
            highlight
            size='large'
            href={url}
            className={classNames({
              [style.spec__link]: true,
              [style['spec__link--opened']]: opened
            })}
          >
            К специальности
          </Button>
          )
        : null}
    </div>
  )
}

export default SpecialtiesCard
